module.exports = __webpack_public_path__ + "img/PG.5aa07f14.svg";